import dayjs from "dayjs";
import 'dayjs/locale/ru';
import 'dayjs/locale/it';

export default {
    data() {
        return {

        }
    },
    methods: {
        getUniqueKey(model) {
            if (model.hasOwnProperty('id')) {
                return model.id;
            }

            if (!model.key) {
                model.key = Date.now();
            }

            return model.key;
        },
        uuid() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        formatDate(date) {
            return date ? dayjs(date).format("DD.MM.YYYY"): '';
        },
        formatDateTime(date) {
            return date ? dayjs(date).format("DD.MM.YYYY hh:mm:ss"): '';
        },
        dateFormatByLocale(date, locale, format = "DD MMMM YYYY") {
            dayjs.locale(locale);

            return date ? dayjs(date, dayjs.OptionType, locale).format(format): '';
        },
        formatDateToYears(date) {
            return date ? dayjs(date).format('YYYY'): '';
        },
        youtubeGetID(url) {
            let ID = '';

            url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

            if(url[2] !== undefined) {
                ID = url[2].split(/[^0-9a-z_\-]/i);
                ID = ID[0];
            } else {
                ID = url;
            }

            return ID;
        },
        downscaleImage(dataUrl, newWidth, imageType="image/jpeg", resolve) {
            let image, oldWidth, oldHeight, newHeight, canvas, ctx, newDataUrl;

            return new Promise((resolve, reject) => {
                image = new Image();
                image.src = dataUrl;

                resolve('Done : ');
            }).then((d)=> {
                setTimeout(function() {
                    oldWidth = image.width;
                    oldHeight = image.height;
                    newHeight = Math.floor(oldHeight / oldWidth * newWidth);

                    // Create a temporary canvas to draw the downscaled image on.
                    canvas = document.createElement("canvas");
                    canvas.width = newWidth;
                    canvas.height = newHeight;

                    // Draw the downscaled image on the canvas and return the new data URL.
                    ctx = canvas.getContext("2d", {preserveDrawingBuffer: true});
                    ctx.fillRect(0,0,0,0);
                    ctx.drawImage(image, 0, 0, newWidth, newHeight);

                    newDataUrl = canvas.toDataURL(imageType, 1);

                    resolve(newDataUrl);
                }, 2000);
            });
        },
        phoneFormatted() {console.log(this.formAuth.login);
            if (this.formAuth.login.indexOf("@") === -1) {
                console.log(this.formAuth.login.indexOf("@"));
                let phone_numeric = new String(this.formAuth.login).replace(/[^\d]+/g, "");
                let phone_formatted = "";

                if (phone_numeric.length == 11) {
                    phone_numeric = phone_numeric.replace(/^./g, "");
                    phone_formatted = phone_numeric.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "+7 $1 $2 $3 $4");
                    this.formAuth.login = phone_formatted;
                }
            }
            console.log(this.formAuth.login);
        },
        validateFloat(value) {
            if (value === '' || value === null) {
                return true;
            }

            return /^[+-]?\d*(\d\.|(\.?\d+))$/.test(value);
        },
        validateKeyPressByFloat(event, prefix) {
            let char = String.fromCharCode(event.charCode);

            let fullNumber = prefix !== null
                ? '' + prefix + char
                : char;

            if (this.validateFloat(fullNumber)) {
                return true;
            }

            event.preventDefault();
        },
    }
};
